import React from "react";
import {connect} from "react-redux";
import {Button, Form, Input, message, Modal, Select, Spin, Table} from "antd";
import './EditUser.scss';
import {
    clearShopsList,
    getShopByPartnerId,
    getUserActivationHistory, getUserCurrentStatus,
    userRequestActions
} from "../../reducers/usersReducer";
import Icon from "../../components/Icon/Icon";
import {userInputLanguageValidation} from "../../utils/userInputLanguageValidation";
import ErrorMessageContent from "../../components/ErrorMessageContent/ErrorMessageContent";
import TextArea from "antd/es/input/TextArea";
import FormHint from "../../components/FormHint/FormHint";
import moment from "moment";
import history from "../../history";

class TableContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editing_user_data: {},
            edited_user_filter: {
                pageNumber: 1
            },
            currentFilter: null,
            isFullNameDisabled: true,
            isEmailDisabled: true,
            isMarketDisabled: true,
            isPartnerShown: false,
            firstNameMaxLength: null,
            actionType: 0,
            currentShopName: null,
            selectedShopId: ''
        }
        this.reasonLength = 0;
        this.showReasonFiled = false;

        const formatDate = (dateString) => {
            if (!dateString) return "";
            const date = moment(dateString);
            return date.isValid() ? date.format("DD/MM/YYYY HH:mm") : "";
        };

        this.columns = [
            {
                title: 'Ամսաթիվ, ժամ',
                dataIndex: 'date',
                render: (value) => {
                    if (!value) return '-';
                    return formatDate(value);
                },
                sorter: (a, b) => {
                    return new Date(a.date) - new Date(b.date);
                },
            },
            {
                title: 'Անուն Ազգանուն',
                dataIndex: 'fullname',
                sorter: (a, b) => this.compareByAlphabet(a.fullname, b.fullname),
            },
            {
                title: 'Մուտքանուն',
                dataIndex: 'login',
                sorter: (a, b) => this.compareByAlphabet(a.login, b.login),
            },
            {
                title: 'Գործողության տեսակ',
                dataIndex: 'actionType',
                render: (isActive) => {
                    return (
                        <span>{isActive ? 'Ակտիվացում' : 'Ապաակտիվացում'}</span>
                    );
                },
                filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => {
                    const handleFilterSelect = (value) => {
                        confirm();
                        this.setState(prevState => ({
                            edited_user_filter: {
                                ...prevState.edited_user_filter,
                                status: value
                            }
                        }), () => this.setDataForUserActivationHistory());

                    };
                    return (
                        <div style={{padding: 8, display: 'flex', flexDirection: 'column', gap: '4px'}}>
                            <button
                                onClick={() => handleFilterSelect(null)}
                                className={`filter-dropdown-btn ${!selectedKeys ? 'filter-dropdown-btn-active' : ''}`}
                            >
                                Բոլորը
                            </button>
                            <button
                                onClick={() => handleFilterSelect(true)}
                                className={`filter-dropdown-btn ${selectedKeys[0] === true ? 'filter-dropdown-btn-active' : ''}`}
                            >
                                Ակտիվացում
                            </button>
                            <button
                                onClick={() => handleFilterSelect(false)}
                                className={`filter-dropdown-btn ${selectedKeys[0] === false ? 'filter-dropdown-btn-active' : ''}`}
                            >
                                Ապաակտիվացում
                            </button>
                        </div>
                    )
                },
                filterMultiple: false,
            },
            {
                width: 300,
                title: 'Մեկնաբանություն',
                dataIndex: 'comment',
            }
        ];
    }

    componentDidMount() {
        const {userType} = this.props.match.params;
        const {location, dispatch} = this.props;
        this.setState({
            editing_user_data: location.state.userData,
            selectedShopId: localStorage.getItem('selectedMarketId') ?? location.state.userData.shopID
        });
        if (!localStorage.getItem('selectedMarketId')) {
            localStorage.setItem('selectedMarketId', location.state.userData.shopID);
        }
        const userLogin = location.state.userData.login
        dispatch(getUserActivationHistory(userLogin))
        dispatch(getUserCurrentStatus(userLogin))
        if (userType == 4) {
            dispatch(getShopByPartnerId(location.state.userData.contractID));
        }
    }

    componentWillUnmount() {
        localStorage.removeItem('selectedMarketId');
        this.setState({
            selectedShopId: ""
        });
    }

    compareByAlphabet = (a, b) => {
        if (a > b) {
            return -1;
        }
        if (a < b) {
            return 1;
        }
        return 0;
    }

    handlePageOnChange = (page_number) => {
        this.setState(prevState => ({
            edited_user_filter: {
                ...prevState.edited_user_filter,
                pageNumber: page_number
            }
        }), () => this.setDataForUserActivationHistory());
    }

    setDataForUserActivationHistory = () => {
        this.props.dispatch(
            getUserActivationHistory(
                this.state.editing_user_data.login,
                this.state.edited_user_filter.pageNumber,
                this.state.edited_user_filter.status,
            )
        );
    }

    handleCancel = () => {
        if (this.props.user_type == 4) {
            this.props.dispatch(clearShopsList());
        }
        history.push('/users');

    }

    handleOk = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values.firstName = values.firstName !== undefined && values.firstName != null ? values.firstName : "";
                values.lastName = values.lastName !== undefined && values.lastName != null ? values.lastName : "";
                values.login = values.login !== undefined && values.login != null ? values.login : "";
                values.email = values.email !== undefined && values.email != null ? values.email : "";
                values.changeReason = values.changeReason !== undefined && values.changeReason != null ? values.changeReason : "";
                values.marketID = values.marketID !== undefined && values.marketID != null ? values.marketID : 0;

                if (values.action_type == 1 || values.action_type == 2) {
                    Modal.confirm({
                        title: 'Համոզվա՞ծ եք, որ անհրաժեշտ է փոփոխել օգտատիրոջ կարգավիճակը',
                        okText: 'Այո',
                        cancelText: 'Ոչ',
                        onOk: () => {
                            this.props.dispatch(userRequestActions(values));
                            this.props.form.setFieldsValue({
                                action_type: '',
                                changeReason: null
                            });
                            this.showReasonFiled = false
                        },
                    });
                } else {
                    this.props.dispatch(userRequestActions(values));
                    if (values.action_type === '3') {
                        const selectedShopName = this.props.shops_list[values.marketID]
                        this.setState({
                            currentShopName: selectedShopName,
                        })
                        localStorage.setItem('selectedMarketId', values.marketID);
                    }
                    this.props.form.setFieldsValue({
                        action_type: '',
                        changeReason: null
                    });
                }
                this.setState({actionType: values.action_type})
            }
        })
    }

    handleUserActionTypeOnChange = (e) => {
        const {user_type} = this.props;
        this.showReasonFiled = (e == 1 || e == 2);
        // check in which action type we need to disable some inputs
        const isFullNameDisabled = e == 1 || e == 2 || e == 3 || e == 5 || e == 6 || e == 8;
        const isEmailDisabled = e == 1 || e == 2 || e == 3 || e == 5 || e == 6 || e == 8;
        const isPasswordDisabled = e == 1 || e == 2 || e == 3 || e == 4 || e == 6 || e == 8;
        const isMarketDisabled = e == 1 || e == 2 || e == 4 || e == 5 || e == 6 || e == 8;
        const isPartnerShown = user_type == 4 && e == 3; // check if user is admin and need to change marketID we need to show partnerID input

        // this.props.form.resetFields();
        this.setState({
            isFullNameDisabled,
            isEmailDisabled,
            isPasswordDisabled,
            isMarketDisabled,
            isPartnerShown
        })
        this.reasonLength = 0;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.user_edited !== this.props.user_edited && this.props.user_edited) {
            if (this.state.actionType != 5) {
                message.success("Օգտատիրոջ տվյալները հաջողությամբ փոփոխվեցին");
            } else {
                message.success("Գաղտնաբառի վերաբերյալ տվյալներն ուղարկվել են օգտատիրոջ էլեկտրոնային հասցեին");
            }
            this.setState({
                editing_user_data: {},
                isFullNameDisabled: true,
                isEmailDisabled: true,
                isMarketDisabled: true,
                isPartnerShown: false,
                actionType: 0
            })
        }
        if (this.props.shops_list !== prevProps.shops_list) {
            this.setState({
                currentShopName: this.props.shops_list[this.state.selectedShopId],
            })
        }
        if (this.props.error_message.type === "get_shop_by_partner_id" && (prevProps.error_message.message !== this.props.error_message.message && this.props.error_message.message !== "")) {
            message.error(<ErrorMessageContent text={this.props.error_message.message}/>, 5);
        }
    }

    render() {
        const {loading} = this.props;
        const {getFieldDecorator} = this.props.form;
        const edited_users_list = this.props.edited_users_list?.userActivationHistory;
        const data = [];

        if (edited_users_list !== undefined) {
            edited_users_list.map((element) => {
                data.push({
                    "fullname": `${element.modifierFirstName} ${element.modifierLastName}`,
                    "login": element.modifier,
                    "access": element.permission,
                    "date": element.changeDate,
                    "actionType": element.isActive,
                    "comment": element.changeReason
                    // "password": element.password != null ? element.password : "-",
                })
            })
        }

        //Total = mi eji objectneri qanak * te qani ej ka @ndhanrapes
        const paginationParams = {
            pageSize: data.length,
            total: data.length * this.props.edited_users_list?.pageCount,
            onChange: this.handlePageOnChange,
            hideOnSinglePage: true,
            current: this.state.edited_user_filter.pageNumber,
        };
        const statusText = this.props.user_current_status ? "Ակտիվ" : "Պասիվ";

        return (
            <>
                <div className="edited-user-form-container">
                    <h1 className="title mb_40 text-uppercase bold fs-22">Օգտատիրոջ տվյալների խմբագրում</h1>
                    <div className="small-12 border-container mb_15">
                        <div className="small-12">
                            <div className="flex-container align-justify">
                                <h4 className="small-6 dark-text-color bold-700">
                                    {
                                        this.state.editing_user_data.firstName + " "
                                        + this.state.editing_user_data.lastName
                                    }
                                </h4>
                                <span className="text-center">{statusText}</span>
                            </div>
                            <div className="name dark-text-color bold-500">{this.state.currentShopName}</div>
                        </div>
                        <div className="small-12 dark-text-color">{this.state.editing_user_data.companyName}</div>
                    </div>

                    <Spin spinning={loading.type === "get_shop_by_partner_id" && loading.loading_state}>
                        <div className="panel_inner">
                            <div className="row">
                                <Form
                                    onSubmit={this.onSubmit}
                                    className="small-12"
                                >
                                    <div className="flex-container">
                                        <Form.Item label="Գործողության տեսակը" className="column small-12">
                                            {getFieldDecorator('action_type', {
                                                initialValue: "",
                                                rules: [{required: true, message: 'դաշտը լրացված չէ'}],
                                            })(
                                                <Select
                                                    onChange={this.handleUserActionTypeOnChange}
                                                >
                                                    {!this.props.user_current_status ?
                                                        <Select.Option key="1">Ակտիվացում</Select.Option>
                                                        :
                                                        <Select.Option key="2">Ապաակտիվացում</Select.Option>
                                                    }
                                                    <Select.Option key="3">Տեղափոխել այլ խանութ</Select.Option>
                                                    <Select.Option key="4">Օգտագործողի տվյալների
                                                        թարմացում</Select.Option>
                                                    <Select.Option key="5">Գաղտնաբառի վերականգնում</Select.Option>
                                                    {/*<Select.Option key="6">Գաղտնաբառի փոփոխում</Select.Option>*/}
                                                    {
                                                        this.state.editing_user_data.isBlocked
                                                            ? (
                                                                <Select.Option key="8">Ապաբլոկավորել</Select.Option>
                                                            )
                                                            : null
                                                    }
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </div>
                                    {this.showReasonFiled && (
                                        <div className="flex-container">
                                            <Form.Item label="Փոփոխության պատճառ" className="column small-12">
                                                {getFieldDecorator('changeReason', {
                                                    initialValue: "",
                                                    rules: [
                                                        {maxLength: 180, message: 'Առավելագույնը՝ 180 սիմվոլ'}
                                                    ],
                                                    onChange: (e) => {
                                                        this.reasonLength = e.target.value.length;
                                                    }
                                                })(
                                                    <div>
                                                        <TextArea maxLength={180}
                                                                  className="textarea-component"
                                                                  style={{
                                                                      height: '90px',
                                                                      minHeight: '58px',
                                                                      resize: 'none',
                                                                      fontSize: '16px'
                                                                  }}
                                                        ></TextArea>
                                                        <FormHint
                                                            className="flex-container small-12 flex-container align-justify">
                                                            <span>Առավելագույնը՝ 180 սիմվոլ</span>
                                                            <span>{this.reasonLength}/180</span>
                                                        </FormHint>
                                                    </div>
                                                )}
                                            </Form.Item>
                                        </div>
                                    )}
                                    <div style={{justifyContent: "space-between"}} className="flex-container">
                                        <Form.Item label="Անուն" className="column small-6">
                                            {getFieldDecorator('firstName', {
                                                initialValue: this.state.editing_user_data.firstName,
                                                rules: [
                                                    {
                                                        required: !this.state.isFullNameDisabled,
                                                        message: 'դաշտը լրացված չէ'
                                                    },
                                                    {
                                                        validator: (rule, value) => (userInputLanguageValidation(value)),
                                                        message: `Խնդրում ենք գրել հայատառ`,
                                                    }
                                                ],
                                            })(
                                                <Input
                                                    type="text"
                                                    disabled={this.state.isFullNameDisabled}
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                        <Form.Item label="Ազգանուն" className="column small-6">
                                            {getFieldDecorator('lastName', {
                                                initialValue: this.state.editing_user_data.lastName,
                                                rules: [
                                                    {
                                                        required: !this.state.isFullNameDisabled,
                                                        message: 'դաշտը լրացված չէ'
                                                    },
                                                    {
                                                        validator: (rule, value) => (userInputLanguageValidation(value)),
                                                        message: `Խնդրում ենք գրել հայատառ`,
                                                    }
                                                ],
                                            })(
                                                <Input
                                                    type="text"
                                                    disabled={this.state.isFullNameDisabled}
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                    </div>
                                    <div style={{justifyContent: "space-between"}} className="flex-container">
                                        <Form.Item label="Մուտքանուն" className="column small-6">
                                            {getFieldDecorator('login', {
                                                initialValue: this.state.editing_user_data.login,
                                                rules: [{required: true, message: 'դաշտը լրացված չէ'}],
                                            })(
                                                <Input
                                                    type="text"
                                                    name="login"
                                                    disabled={true}
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                        <Form.Item label="Էլ․ հասցե" className="column small-6">
                                            {getFieldDecorator('email', {
                                                initialValue: this.state.editing_user_data.email,
                                                rules: [{
                                                    required: !this.state.isEmailDisabled,
                                                    message: 'դաշտը լրացված չէ'
                                                }],
                                            })(
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    suffix={<Icon type="person" size={15}/>}
                                                    disabled={this.state.isEmailDisabled}
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                    </div>
                                    <div style={{justifyContent: "space-between"}} className="flex-container">
                                        <Form.Item label="Խանութ" className="column small-12">
                                            {getFieldDecorator('marketID', {
                                                initialValue: this.state.selectedShopId ? this.state.selectedShopId.toString() : "",
                                                rules: [{
                                                    required: !this.state.isMarketDisabled,
                                                    message: 'դաշտը լրացված չէ'
                                                }],
                                            })(
                                                <Select
                                                    disabled={this.state.isMarketDisabled}
                                                >
                                                    {Object.keys(this.props.shops_list).map((index) => (
                                                        <Select.Option
                                                            key={index}>{this.props.shops_list[index]}</Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </div>

                                </Form>
                            </div>
                        </div>
                    </Spin>

                    <div className="btn-group align-right mb_45 flex-container">
                        <Button key="back" className="base_btn base_btn-red" onClick={this.handleCancel}>
                            Չեղարկել
                        </Button>
                        <Button
                            loading={this.props.loading.type === "user_request_actions_load" && this.props.loading.loading_state}
                            key="submit"
                            className="base_btn base_btn-green"
                            type="primary"
                            disabled={this.showReasonFiled && !this.reasonLength}
                            onClick={this.handleOk}
                        >
                            Պահպանել
                        </Button>,
                    </div>
                </div>
                <Table pagination={paginationParams} columns={this.columns} dataSource={data}/>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user_type: state.initReducer.user_type,
        market_id: state.initReducer.market_id,
        loading: state.usersReducer.loading,
        error_message: state.usersReducer.error_message,
        user_edited: state.usersReducer.user_edited,
        updated_users_data: state.usersReducer.updated_users_data,
        users_list: state.usersReducer.users_list,
        edited_users_list: state.usersReducer.edited_users_list,
        user_current_status: state.usersReducer.user_current_status,
        shops_list: state.usersReducer.shops_list,
        partners_list: state.usersReducer.partners_list,
        users_list_filter: state.usersReducer.filter,
    }
}

const TableFormContainer = Form.create()(TableContainer);

export default connect(mapStateToProps)(TableFormContainer);

